module.exports = __webpack_public_path__ + "img/trash-icon.3c131a97.svg";